"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontAwesomeIcon = exports.fontAwesomeIconClasses = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
exports.fontAwesomeIconClasses = {
    icon: "FontAwesomeIcon",
};
// gotten from https://mui.com/components/icons/#font-awesome
exports.FontAwesomeIcon = (0, react_1.forwardRef)((props, ref) => {
    const { icon, sx = [], ...otherProps } = props;
    const { icon: [width, height, , , svgPathData], } = icon;
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { ref: ref, viewBox: `0 0 ${width} ${height}`, sx: [
            {
                color: "currentColor",
                width: "1em",
                height: "1em",
                fontSize: "16px",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...otherProps, classes: {
            ...(otherProps.classes ?? {}),
            root: (0, clsx_1.default)(exports.fontAwesomeIconClasses.icon, otherProps.classes?.root),
        }, children: typeof svgPathData === "string" ? ((0, jsx_runtime_1.jsx)("path", { d: svgPathData })) : (
        /**
         * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
         * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
         * of a duotone icon. 40% is the default opacity.
         *
         * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
         */
        svgPathData.map((pathData, i) => ((0, jsx_runtime_1.jsx)("path", { style: { opacity: i === 0 ? 0.4 : 1 }, d: pathData }, pathData)))) }));
});
